import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { shareReplay, tap } from 'rxjs/operators';
import { GalleryThumbnail } from '../model/galleryThumbnail';
import { environment } from './../../environments/environment';
import { GoogleAnalyticsService } from './google-analytics.service';

interface GalleryResponse {
  result: GalleryThumbnail[];
  metadata: { pages: unknown[]; totalCount: number; pageSize: number };
}

@Injectable({ providedIn: 'root' })
export class GalleryService {
  private http = inject(HttpClient);
  private googleAnalyticsService = inject(GoogleAnalyticsService);


  gallery$: Observable<GalleryResponse>;

  url = (gallery: string, page: number): string => `${environment.api}/v1/gallery/${gallery}?page=${page}`;

  fetch(galleryCode: string, page = 1): Observable<GalleryResponse> {
    this.gallery$ = this.http.get<GalleryResponse>(this.url(galleryCode, page)).pipe(
      shareReplay(1),
      tap((data: GalleryResponse) => {
        data.result.forEach(galleryItem => {
          GalleryThumbnail.enrichGalleryItem(galleryItem);
        });
        data.metadata.pages = Array(Math.ceil(data.metadata.totalCount / data.metadata.pageSize));
      })
    );
    this.googleAnalyticsService.emitEvent('view_item_list', 'engagement');
    return this.gallery$;
  }
}
